import { useState, useEffect } from 'react';
import ReactBody from 'react-body';
import { animateScroll as scroll, scroller } from 'react-scroll';
import AOS from "aos";
import "aos/dist/aos.css";

// images
import BannerImage from '../../images/clients/pages/kennedys/banner.png';
import KennedysInsightHome from '../../images/clients/pages/kennedys/kennedys-insight/home.png';
import KennedysInsightHomeTooltip from '../../images/clients/pages/kennedys/kennedys-insight/home-tooltip.png';
import KennedysInsightOverview from '../../images/clients/pages/kennedys/kennedys-insight/overview.png';
import KennedysInsightClients from '../../images/clients/pages/kennedys/kennedys-insight/clients.png';

// includes
import ProjectsNav from '../menus/ProjectsNav';
import ProjectsMenu from '../menus/ProjectsMenu';

function Kennedys() {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        // Set a timeout to trigger the fade-in effect
        setTimeout(() => {
        setIsVisible(true); // Trigger the fade-in after the page has loaded
        }, 0); // You can delay this a bit if needed, but 0 will work for an immediate fade-in
    }, []);

    
    useEffect(() => {
        AOS.init({
            duration: 1000, // Default animation duration
            once: true,     // Whether animation should happen only once
        });
        AOS.refresh(); // Refresh AOS to re-apply animations if content changes dynamically
    }, []);

    scroll.scrollToTop();
    
    const scrollToSection = (sectionId, index, event) => {
        event.preventDefault();  // Prevent the default anchor scroll behavior
        scroller.scrollTo(sectionId, {
            duration: 200,   // Add duration for smooth scrolling
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -50,     // Adjust based on your needs
        });
    };

    return (
        <div className={`page-fade-in ${isVisible ? "visible" : ""}`}>
            <ReactBody className="kennedys projects" />
            <ProjectsNav />
            <div className="banner kennedys-active">
                <ProjectsMenu />
                <nav className="downloads-menu">
                    <h3 className="white align-right border-none">Related</h3>
                    <ul>
                        <li>
                            <a href="https://kennedys-insight.netlify.app/" title="Will open in a New Window" rel="noopener noreferrer" target="_blank">Kennedys Insight</a>
                        </li>
                    </ul>
                </nav>
                <header className="projects-header">
                    <h1>Kennedys Law</h1>
                    <ul className="umg-overview">
                        <li>
                            <h3>Client</h3>
                            <p>Kennedys Law</p>
                        </li>
                        <li>
                            <h3>Platform</h3>
                            <p>Desktop & Mobile</p>
                        </li>
                        <li>
                            <h3>Services</h3>
                            <p>UX/UI Design & Front-End Dev</p>
                        </li>
                        <li>
                            <h3>When</h3>
                            <p>June 2025 - Present</p>
                        </li>
                    </ul>
                </header>
                <img src={BannerImage} alt="" data-aos="fade-in" data-aos-duration="1000" />
            </div>
            {/* <nav className="mini-menu flex-group flex-column flex-nowrap flex-end">
                <a
                    href='#section-one'
                    onClick={(e) => {
                        scrollToSection('section-one', e);
                        setActiveClass(1);
                    }}
                >
                    <span className='flex-group'>
                        <span className='menu-name'>Kennedys Insight</span>
                        <span className='material-icons'>design_services</span>
                    </span>
                </a>
                <a
                    href='#section-two'
                    onClick={(e) => {
                        scrollToSection('section-two', e);
                        setActiveClass(2);
                    }}
                >
                    <span className='flex-group'>
                        <span className='menu-name'>Figma Component Library</span>
                        <span className='material-icons'>local_library</span>
                    </span>
                </a>
            </nav> */}
            <div className="container-fluid col-xs-12 col-sm-12 col-md-12 col-lg-12 umg-mobile">
                <div className="row" id="section-one">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="flex-group space-between flex-align-center">
                            <h2>Kennedys Law</h2>
                        </div>
                        <p className='mw800'>
                                Kennedys Insight – Global Interactive Map is a data-driven platform I designed 
                                in Figma and built in Angular to give lawyers and partners an at-a-glance view 
                                of firm-wide activity across offices, staff, clients, and revenue. The application 
                                consolidates multiple legacy systems into one intuitive interface, visualising 
                                data through an interactive world map with region overlays, donut charts, and 
                                contextual dashboards. It delivers instant access to key metrics such as open 
                                matters, revenue by region, and staff distribution, streamlining business insight 
                                and strategic decision-making across 46 offices worldwide. The platform has been 
                                rolled out globally to Kennedys’ lawyers’ desktops, providing a cohesive, 
                                high-performance user experience and a single source of truth for firm analytics.
                            </p>
                            <p>
                            <a
                                className="margin-top-small red flex-align-center"
                                href="https://kennedys-insight.netlify.app/"
                                title="Will open in a New Window"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <span className="material-icons">insert_link</span>You can visit Kennedys Insight here.
                            </a>
                            </p>
                        <img className="w-100" src={KennedysInsightHome} alt="" />
                    </div>
                </div>

                <div className="row" id="section-two">
                    <section className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <h3>Tooltips</h3>
                        <img src={KennedysInsightHomeTooltip} className="w-100" alt="" />
                        <h3>Overview</h3>
                        <img src={KennedysInsightOverview} className="w-100" alt="" />
                        <h3>Client search</h3>
                        <img src={KennedysInsightClients} className="w-100" alt="" />
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Kennedys;
